import { casestudyTypes } from '@constants';

const metaDescriptionHnavi = `「発注ナビ」は、システム開発・Web制作案件に特化したビジネスマッチングサービスです。ITに詳しい専門スタッフが発注者様と開発会社様をつなぎ、プロジェクトの成功をサポートします。`;
const metaDescriptionLounge = `発注ラウンジは、システム開発・Webサイト制作の発注に役立つノウハウや、「発注ナビ」で実際にシステム開発を発注された方のインタビューなど、ITでお困りの皆様をサポートする情報を掲載しています。`;

export const getMetaDescription = ({
  post,
  category,
}: {
  post?: {
    title?: string | null | undefined;
    hnavi?:
      | {
          hnaviMainCategory?: string | null | undefined;
          hnaviReferenceKey?: string | null | undefined;
        }
      | null
      | undefined;
  };
  category?: {
    slug?: string | null | undefined;
    name?: string | null | undefined;
  };
} = {}) =>
  !post && !category
    ? metaDescriptionLounge
    : category?.slug === 'interview'
    ? `インタビュー一覧｜${metaDescriptionLounge}`
    : `${post?.title || category?.name}｜${
        post?.hnavi?.hnaviReferenceKey &&
        [...Object.keys(casestudyTypes), 'cost', 'feature'].includes(
          post?.hnavi?.hnaviReferenceKey
        )
          ? metaDescriptionHnavi
          : metaDescriptionLounge
      }`;
